import { render, staticRenderFns } from "./ApproveDialog.pug?vue&type=template&id=3d570636&scoped=true&lang=pug&"
import script from "./ApproveDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveDialog.vue?vue&type=script&lang=js&"
import style0 from "./ApproveDialog.scss?vue&type=style&index=0&id=3d570636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d570636",
  null
  
)

export default component.exports